import React from 'react';
import { YandexLogoRu } from './LogoRu';
import { YandexLogoEn } from './LogoEn';

const countriesWithRuIcon: string[] = ['ua', 'ru', 'by'];

export const YandexIcon: React.FunctionComponent<{
  lang?: string;
}> = (props) =>
  countriesWithRuIcon.includes(props.lang) ? (
    <YandexLogoRu />
  ) : (
    <YandexLogoEn />
  );
YandexIcon.displayName = 'YandexIcon';
